module.exports = __webpack_public_path__ + "img/aspect-ratio.a528ec29.svg";